import { useState } from "react"

import { ParadiseSelectDeviceReading } from "src/components/Paradise/ParadiseDevices/ParadiseDeviceReadings/ParadiseSelectDeviceReading"
import { DeviceReadingType } from "src/data/devices/types/deviceTypes"
import { TParadiseDevice } from "src/data/paradise/paradiseDevices/types/paradiseDeviceQueryTypes"
import { MDialog } from "src/ui/Dialog/MDialog"

const SELECT_DEVICE_READING_FORM = "select-device-reading-form"

export function ParadiseSelectDeviceReadingTypeDialog({
  title,
  open,
  onClose,
  device,
  initiailDeviceReading,
  onSubmit,
}: {
  title: string
  open: boolean
  onClose: () => void
  device: TParadiseDevice
  initiailDeviceReading?: DeviceReadingType
  onSubmit: (deviceReading: DeviceReadingType) => void
}) {
  const [selectedDeviceReading, setSelectedDeviceReading] = useState<
    DeviceReadingType | undefined
  >(initiailDeviceReading)
  const [searchedDeviceReading, setSearchedDeviceReading] = useState("")

  function closeDialog() {
    setSearchedDeviceReading("")
    setSelectedDeviceReading(undefined)
    onClose()
  }

  return (
    <MDialog
      title={title}
      open={open}
      onClose={closeDialog}
      formId={SELECT_DEVICE_READING_FORM}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()

          if (selectedDeviceReading) {
            onSubmit(selectedDeviceReading)
            closeDialog()
          }
        }}
        id={SELECT_DEVICE_READING_FORM}
      >
        <ParadiseSelectDeviceReading
          device={device}
          selectedDeviceReading={selectedDeviceReading ?? ""}
          searchedValue={searchedDeviceReading}
          onChange={(deviceReading) => {
            setSelectedDeviceReading(deviceReading as DeviceReadingType)
          }}
          input={searchedDeviceReading}
          onInput={setSearchedDeviceReading}
          required
        />
      </form>
    </MDialog>
  )
}
